export const environment = {
  production: true,
  twoFactorAuthentication: true,
  newInvestorStepOptional:false,
  sslEnabled: true,
  nfoLink:'https://itiamc.com/nfo' 
};
